import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import { getBrandServ } from "../../services/brand.services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";
import { getTagSetServ } from "../../services/tag.service";
import { getProductTypeServ } from "../../services/productType.service";
import { addProductServ, getProductServ } from "../../services/product.services";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { getCategoryServ } from "../../services/category.service";
function AddProduct() {
  const descriptionRef = useRef("");
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  const editor = useRef(null);
  const contentRef = useRef("");
  const shortDescConfig = {
    placeholder: "e.g. Write a brief overview of the product for quick reading...",
    height: "300px",
  };
  const fullDescConfig = {
    placeholder: "e.g. Write detailed information including ingredients, nutritional facts, and usage...",
    height: "300px",
  };


  const [content, setContent] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    slug: "",
    tags: [],
    productType: "",
    categoryId: "",
    hsnCode: "",
    GTIN: "",
    shortDescription: "",
    productApperence: "",
    description: "",
  });
  const [tags, setTags] = useState([]);
  const getTagListFunc = async () => {
    try {
      let response = await getTagSetServ({ status: true });
      if (response?.data?.statusCode === "200") {
        setTags(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [productType, setProductType] = useState([]);
  const getProductListFunc = async () => {
    try {
      let response = await getProductTypeServ({ status: true });
      if (response?.data?.statusCode === "200") {
        setProductType(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const [categoryList, setCategoryList] = useState([]);
  const getCategoryListFunc = async () => {
    try {
      let response = await getCategoryServ({ status: true });
      if (response?.data?.statusCode === "200") {
        setCategoryList(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTagListFunc();
    getProductListFunc();
    getCategoryListFunc();
  }, []);
  const [loader, setLoader] = useState(false);
  const [slugError, setSlugError] = useState("");

  // slug pehle se to nahi hai — live check
  const checkSlugUnique = async () => {
    const slug = (formData?.slug || "").trim();
    if (!slug) {
      setSlugError("");
      return;
    }
    try {
      const listRes = await getProductServ({ pageNo: 1, pageCount: 100000 });
      const list = listRes?.data?.data || [];
      const duplicate = list.find(
        (p) => (p?.slug || "").trim().toLowerCase() === slug.toLowerCase()
      );
      setSlugError(
        duplicate ? "This slug already exists. Please use a unique slug." : ""
      );
    } catch (e) { }
  };

  const handleSubmit = async () => {
    setLoader(true);
    try {
      // slug required + unique
      const slug = (formData?.slug || "").trim();
      if (!slug) {
        toast.error("Slug is required");
        setLoader(false);
        return;
      }
      try {
        const listRes = await getProductServ({ pageNo: 1, pageCount: 100000 });
        const list = listRes?.data?.data || [];
        const duplicate = list.find(
          (p) => (p?.slug || "").trim().toLowerCase() === slug.toLowerCase()
        );
        if (duplicate) {
          setSlugError("This slug already exists. Please use a unique slug.");
          toast.error("This slug already exists. Please use a unique slug.");
          setLoader(false);
          return;
        }
      } catch (e) {
        // agar list fetch fail ho to backend uniqueness check pe chhod do
      }

      let finalPayload;
      const shortDescription = contentRef.current;
      const description = descriptionRef.current;
      if (formData?.createdByAdmin !== "No") {
        finalPayload = {
          name: formData?.name,
          slug: formData?.slug,
          tags: formData?.tags,
          productType: formData?.productType,
          categoryId: formData?.categoryId,
          hsnCode: formData?.hsnCode,
          GTIN: formData?.GTIN,
          shortDescription: shortDescription,
          productApperence: formData?.productApperence,
          description: description
        };
      }
      if (formData?.createdByAdmin === "No") {
        finalPayload = {
          name: formData?.name,
          slug: formData?.slug,
          tags: formData?.tags,
          productType: formData?.productType,
          categoryId: formData?.categoryId,
          madeIn: formData?.madeIn,
          hsnCode: formData?.hsnCode,
          GTIN: formData?.GTIN,
          shortDescription: shortDescription,
          createdBy: formData?.createdBy,
          productApperence: formData?.productApperence,
          description: description,
        };
      }
      let response = await addProductServ(finalPayload);
      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message);
        setFormData({
          name: "",
          tags: [],
          productType: "",
          categoryId: "",
          madeIn: "",
          hsnCode: "",
          GTIN: "",
          createdBy: "",
          createdByAdmin: "",
          productApperence: "",
          description: ""
        });
        contentRef.current = "";
        descriptionRef.current = "";
        setContent("");
        setDescription("");
        navigate("/update-product-step2/" + response?.data?.data?._id);

      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
    setLoader(false);
  };
  const [brandList, setBrandList] = useState([]);
  const getBrandList = async () => {
    try {
      let response = await getBrandServ({ status: true });
      if (response?.data?.statusCode === "200") {
        setBrandList(response?.data?.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    getBrandList();
  }, []);

  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="Product Management" selectedItem="Add Product" />
      <div className="mainContainer">
        <TopNav />
        <div className="p-lg-4 p-md-3 p-2">
          <div
            className="row mx-0 p-0"
            style={{
              position: "relative",
              top: "-75px",
              marginBottom: "-75px",
            }}
          ></div>

          <div className="mt-3">
            <div className="card-body px-2">
              <div className="table-responsive table-invoice">
                <div className="d-flex">
                  <h4
                    className="p-2 text-dark shadow rounded mb-4 "
                    style={{ background: "#05E2B5" }}
                  >
                    Add Product : Step 1/4
                  </h4>
                </div>
              </div>
              <div className="row">
                <div className="col-6 mb-3">
                  <label>Product Name*</label>
                  <input
                    value={formData?.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e?.target?.value })
                    }
                    className="form-control"
                    style={{ height: "45px" }}
                    placeholder="e.g. Magical Masala Makhana"
                  />
                </div>
                <div className="col-6 mb-3">
                  <label>
                    Slug<span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    value={formData.slug}
                    onChange={(e) => {
                      setFormData({ ...formData, slug: e.target.value });
                      setSlugError("");
                    }}
                    onBlur={checkSlugUnique}
                    className={`form-control ${slugError ? "is-invalid" : ""}`}
                    placeholder="e.g. magical-masala-makhana"
                  />
                  <small className="text-danger">
                    {slugError ? slugError : "Slug must be unique"}
                  </small>
                </div>
                <div className="col-4 mb-3">
                  <label>Category</label>
                  <Select
                    isMulti
                    options={categoryList?.map((v) => ({
                      label: v?.name,
                      value: v?._id,
                    }))}
                    onChange={(selectedOptions) =>
                      setFormData({
                        ...formData,
                        categoryId: selectedOptions.map((option) => option.value),
                      })
                    }
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Categories (e.g., Snacks, Healthy)"
                  />
                </div>
                <div className="col-4 mb-3">
                  <label>Brand</label>
                  <select
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        brandId: e?.target.value,
                      })
                    }
                    value={formData?.brandId}
                    className="form-control"
                  >
                    <option value="">Select Brand (e.g. Frisky)</option>
                    {brandList?.map((v, i) => {
                      return <option value={v?._id}>{v?.name}</option>;
                    })}
                  </select>
                </div>
                <div className="col-4 mb-3">
                  <label>Product Type</label>
                  {/* <Select
                    value={
                      formData.productType
                        ? {
                            label: formData.productType,
                            value: formData.productType,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      setFormData({
                        ...formData,
                        productType: selected?.value || "",
                      })
                    }
                    // options={productTypeOptions}
                  /> */}
                  <select className="form-control">
                    <option value="">Select Product Type (e.g. Simple Product)</option>
                    {productType?.map((v, i) => {
                      return (
                        <option value={v?.name}>{v?.name}</option>
                      )
                    })}
                  </select>
                </div>
                <div className="col-6 mb-3">
                  <label>Tags</label>
                  <Select
                    isMulti
                    options={tags?.map((v) => ({
                      label: v?.name,
                      value: v?._id,
                    }))}
                    onChange={(selectedOptions) =>
                      setFormData({
                        ...formData,
                        tags: selectedOptions.map((option) => option.label), // only array of string IDs
                      })
                    }
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select Tags (e.g., Roasted, Gluten Free)"
                  />
                </div>


                <div className="col-6 mb-3">
                  <label>Special Apperence</label>
                  <select onChange={(e) => setFormData({ ...formData, productApperence: e?.target?.value })} className="form-control">
                    <option value="">Select Special Appearance (e.g. Best Seller)</option>
                    <option>Popular</option>
                    <option>Best Seller</option>
                    <option>Daily Best Sell</option>
                  </select>
                </div>

                <div className="col-6 mb-3">
                  <label>HSN Code</label>
                  <input
                    className={"form-control "}
                    style={{ height: "45px" }}
                    value={formData?.hsnCode}
                    type="number"
                    onChange={(e) => { setFormData({ ...formData, hsnCode: e?.target?.value }) }}
                    placeholder="e.g. 19041090"
                  />

                </div>

                <div className="col-6 mb-3">
                  <label>GTIN Code</label>
                  <input
                    className="form-control"
                    style={{ height: "45px" }}
                    value={formData?.GTIN || ""}
                    type="number"
                    onChange={(e) => {

                      setFormData({ ...formData, GTIN: e?.target?.value });
                    }
                    }
                    placeholder="e.g. 08908012345678"
                  />
                </div>

                <div className="col-12 mb-3">
                  <label>Short Description*</label>
                  <JoditEditor
                    ref={editor}
                    config={shortDescConfig}
                    value={content}
                    onChange={(newContent) => {
                      contentRef.current = newContent;
                    }}
                  />
                </div>
                <div className="col-12 mb-3">
                  <label>Product Description</label>
                  <JoditEditor
                    ref={editor}
                    config={fullDescConfig}
                    value={description}
                    onChange={(newContent) => {
                      descriptionRef.current = newContent;
                    }}
                  />
                </div>
                {loader ? (
                  <div className="col-12">
                    <button
                      className="btn btn-primary w-100"
                      style={{
                        background: "#05E2B5",
                        border: "none",
                        borderRadius: "24px",
                        opacity: "0.6",
                      }}
                    >
                      Saving ...
                    </button>
                  </div>
                ) :
                  formData?.tags?.length > 0 &&
                    formData?.name
                    ? (
                      <div className="col-12">
                        <button
                          className="btn btn-primary w-100"
                          style={{
                            background: "#05E2B5",
                            border: "none",
                            borderRadius: "24px",
                          }}
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    ) : (
                      <div className="col-12">
                        <button
                          className="btn btn-primary w-100"
                          style={{
                            background: "#61ce70",
                            border: "none",
                            borderRadius: "24px",
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddProduct;

